import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import React, { ComponentProps } from 'react';
import { cn } from '../../utils/cn';
import { exhaustiveCheck } from '../../utils/exhaustive-check';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  const icon = getCheckboxIcon({ checked: props.checked });

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded-[4px] border border-border ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-0 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-0 data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
        <div className="h-3 w-3">{icon}</div>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

type GetCheckboxIconArgs = {
  checked: ComponentProps<typeof CheckboxPrimitive.Root>['checked'];
};

const getCheckboxIcon = ({ checked }: GetCheckboxIconArgs) => {
  if (!checked) {
    return null;
  }

  const iconClassName = 'h-full w-full text-black';

  switch (checked) {
    case 'indeterminate':
      return <Minus className={iconClassName} />;
    case true:
      return <Check className={iconClassName} />;
    default:
      return exhaustiveCheck(checked);
  }
};
